const axios = require('axios');

export default class AddressController {
  constructor(resource) {
    this._resource = resource;
  }

  async uploadPhotos(data) {
    return await this._resource('cnhUpload/photo')
      .save(data)
      .then(res => res)
      .catch(e => {
        throw e;
      });
  }
  eventToBlob(e) {
    let image = e;
    // compactação inicio
    const width = 100;
    const fileName = e.name;
    const reader = new FileReader();
    reader.readAsDataURL(e);
    reader.onload = event => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const elem = document.createElement('canvas');
        const scaleFactor = width / img.width;
        elem.width = width;
        elem.height = img.height * scaleFactor;
        const ctx = elem.getContext('2d');
        // img.width and img.height tem as dimensões originais
        ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
        ctx.canvas.toBlob(
          blob => {
            const file = new File([blob], fileName, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            image = file;
          },
          'image/jpeg',
          1
        );
      };
    };
    return image;
  }

  async uploadCnhImage(e, user_id) {
    const image = this.eventToBlob(e);
    let data = new FormData();
    data.append('cnhImage', image);
    data.append('user_id', user_id);
    await this.uploadPhotos(data).catch(err => {
      throw err.body;
    });
  }

  async uploadCnhPdf(e, user_id) {
    const cnhImage = e;
    let data = new FormData();
    data.append('cnhImage', cnhImage);
    data.append('user_id', user_id);

    await this.uploadPhotos(data)
      .then(res => res)
      .catch(err => {
        throw 'Erro ao realizar leitura do documento';
      });
  }
}
